'use strict';
export default function switchToHostService($http, $location, $window, NotificationService, SWITCH_TO_HOST_CONFIG) {

  return { switchToHost };

  function switchToHost(merchant) {
    if (!merchant.id) {
      NotificationService.error('Invalid merchant ID');
      return;
    }

    $http.post(SWITCH_TO_HOST_CONFIG.AUDIT_ENDPOINT + '/' + merchant.id, {})
      .then(function(res) {
        if (res.data) {
          const sessionToken = res.data;
          if (!sessionToken) {
            NotificationService.error('Invalid session token');
            return;
          }

          const params = `?merchantId=${ merchant.publicId }&sessionToken=${ sessionToken }`;
          $window.location = `${ SWITCH_TO_HOST_CONFIG.HOST_LOCATION }${ params }`;
        }
      })
      .catch(function(err) {
        if (err.data && err.data.errors && err.data.errors[0]) {
          NotificationService.error(err.data.errors[0].message);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/switchToHost.service.js